<template>
  <div class="share-header">
    <div class="share-wrapper">
      <div class="wrapper-logo">
        <img
          :src="icons.Logo_Blue"
          alt="logo">
      </div>
      <div
        class="wrapper-website"
        @click="toWebsite">
        <p>{{ $t('enterWebSite') }}</p>
        <img
          :src="icons.Chevron_Blue"
          alt="website">
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import { Logo_Blue, Chevron_Blue } from '@/images'
import shareText from '@/config/share'
export default {
  data () {
    return {
      icons: {
        Logo_Blue,
        Chevron_Blue
      }
    }
  },
  methods: {
    toWebsite () {
      window.open(shareText.yflife, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.share-header {
  .share-wrapper {
    position: fixed;
    top: 0;
    z-index: 999;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    max-width: 375px;
    height: 48px;
    padding: 12px 5px 12px 15px;
    background: $color-bg-white;
    .wrapper-logo {
      img {
        width: 124px;
        height: 20px;
      }
    }
    .wrapper-website {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      p {
        @include font-Medium;

        color: $color-primary;
        font-size: $span-font-size;
        line-height: 18px;
      }
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
